<template>
  <div id="">
    <div class="emd-stripe">
      <div class="emd-bounds">
        <div class="emd-section fade-in" >
          <div v-if="isLoading && !requestFailed" class="emd-box _state_loading"></div>
          <p v-else-if="!isLoading && requestFailed" class="emd-text _color_danger _align_center">{{$t('edit.error')}}</p>
          <div v-else class="emd-box">
            <EmdBoxHeader :title="$t('breadcrumb.edit.generalData')">
              <button class="emd-btn _color_secondary _type_text" v-show="disabled" @click="disabled = !disabled">{{$t('edit.edit')}}</button>
            </EmdBoxHeader>
            <div class="emd-box__content">
              <div class="emd-alert _color_success hideFeedback" ref="feedback">
                <p>{{$t('edit.form.generalData.success_message')}}</p>
              </div>
              <error-list :items="errors"></error-list>
              <form ref="formGeneralData" @submit.prevent="saveGeneralData" novalidate="true">
                <fieldset>
                  <div class="emd-flex _direction_column _direction_row_md">
                    <div class="emd-flex-item _basis_12 _basis_6_md">
                      <div class="emd-chunk">
                        <div class="emd-form-group">
                          <label class="emd-label u-required" for="appName">{{$t('edit.form.generalData.name')}}:</label>
                          <input name="name" class="emd-input" id="appName" type="text" v-model="name" @focus="sendFsEvent('nome-edit-app')" @focusout="form.validateInput" :disabled="disabled" required>
                        </div>
                      </div>

                      <div class="emd-chunk">
                        <div class="emd-form-group">
                          <label class="emd-label u-required" for="appCategory">{{$t('edit.form.generalData.category')}}:</label>
                          <div class="emd-select" id="appCategory">
                            <select name="category" @focus="sendFsEvent('categoria-edit-app')" v-model="category" :disabled="disabled" required>
                              <option :value="elem.value" v-for="(elem, index) in applicationCategories" :key="index">{{elem.description}}</option>
                            </select>
                            <div class="emd-select__arrow"></div>
                          </div>
                          <p class="emd-input-helper">{{$t('edit.form.generalData.category_helper')}}</p>
                        </div>
                      </div>

                      <div class="emd-chunk" v-if="isRoot" >
                        <div class="emd-form-group">
                          <label class="emd-label u-required">{{$t('edit.form.generalData.applicationType')}}:</label>
                          <div class="emd-form-group _display_inline">
                            <label class="emd-radio-button" for="integration1">
                              <input class="emd-radio-button__input" name="type" type="radio" id="integration1" value="ExternalApp" v-model="type" :disabled="disabled" required>
                              <div class="emd-radio-button__area"></div>
                              {{$t('edit.form.generalData.externalType')}}
                            </label>
                            <label class="emd-radio-button" for="integration2">
                              <input class="emd-radio-button__input" name="type" type="radio" id="integration2" value="InternalApp" v-model="type" :disabled="disabled" required>
                              <div class="emd-radio-button__area"></div>
                              {{$t('edit.form.generalData.internalType')}}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div class="emd-chunk" v-if="isRoot">
                        <div class="emd-form-group">
                          <label class="emd-checkbox" for="isFree">
                            {{$t('edit.form.generalData.isFree')}}
                            <input
                              class="emd-checkbox__input"
                              type="checkbox"
                              id="isFree"
                              name="isFree"
                              v-model="isFree"
                              :disabled="disabled"
                            />
                            <div class="emd-checkbox__area"></div>
                          </label>
                          <div class="emd-input-helper"></div>
                        </div>
                      </div>

                      <div class="emd-chunk" v-if="isRoot">
                        <div class="emd-form-group">
                          <label class="emd-checkbox" for="is_synchronous">
                            {{$t('edit.form.generalData.is_synchronous')}}
                            <input
                              class="emd-checkbox__input"
                              type="checkbox"
                              id="is_synchronous"
                              name="is_synchronous"
                              v-model="isSynchronous"
                              :disabled="disabled"
                            />
                            <div class="emd-checkbox__area"></div>
                          </label>
                          <div class="emd-input-helper">
                            <p>
                              Saiba mais sobre esta função através desta <a target="_blank" rel="noopener" href="https://docs.pagar.me/docs/instalacao-app#instalação-síncrona">documentação</a>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="emd-chunk" v-if="isRoot">
                        <label class="emd-label">{{$t('edit.form.generalData.multiInstall')}}:</label>
                        <div class="emd-form-group">
                          <label class="emd-checkbox" for="allowMultiInstallPerAccount">
                            {{$t('edit.form.generalData.allowMultiInstallPerAccount')}}
                            <input
                              class="emd-checkbox__input"
                              type="checkbox"
                              id="allowMultiInstallPerAccount"
                              name="allowMultiInstallPerAccount"
                              v-model="allowMultiInstallPerAccount"
                              :disabled="disabled"
                            />
                            <div class="emd-checkbox__area"></div>
                          </label>
                          <div class="emd-input-helper"></div>
                        </div>
                      </div>

                      <div class="emd-chunk">
                        <div class="emd-form-group">
                          <label class="emd-label" for="suportEmail">{{$t('edit.form.generalData.email')}}:</label>
                          <input class="emd-input" name="supportEmail" id="suportEmail" type="email" v-model="supportEmail" @focusout="form.validateInput" @focus="sendFsEvent('email-suporte')" :disabled="disabled">
                        </div>
                      </div>

                      <div class="emd-chunk">
                        <div class="emd-form-group">
                          <label class="emd-label" for="suportUrl">{{$t('edit.form.generalData.url')}}:</label>
                          <input class="emd-input" name="appUrl" id="suportUrl" type="url" v-model="url" @focus="sendFsEvent('url-site')" @focusout="form.validateInput" :disabled="disabled">
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <div class="emd-flex _justify_flex-end" v-show="!disabled">
                    <div class="emd-flex-item _shrink">
                      <button class="emd-btn _color_primary _type_text" type="button" @click="disabled = !disabled">{{$t('edit.cancel')}}</button>
                    </div>
                    <div class="emd-flex-item _shrink">
                      <button class="emd-btn _color_secondary" type="submit" :disabled="!formIsValid">{{$t('edit.save')}}</button>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ErrorList from '@/components/project/ErrorList.vue'
import EmdBoxHeader from '@/components/emerald/EmdBoxHeader'
import form from '@/plugins/form.js'
import sendFsCustomEvent from '@/mixins/sendFsCustomEvent'

export default {
  name: 'ApplicationGeneralData',
  components: {
    ErrorList,
    EmdBoxHeader
  },
  mixins: [sendFsCustomEvent],
  computed: {
    isLoading () {
      return this.$store.state.application.detail.isLoading
    },
    requestFailed () {
      return this.$store.state.application.detail.requestFailed
    },
    isRoot () {
      return this.$store.state.user.profile.user.is_root || this.$store.state.user.profile.user.is_employee
    },
    name: {
      get () {
        if (this.body.name === undefined) {
          this.body.name = this.$store.state.application.detail.name
        }
        return this.body.name
      },
      set (value) {
        this.body.name = value
      }
    },
    category: {
      get () {
        if (this.body.category === undefined) {
          this.body.category = this.$store.state.application.detail.classification.category
        }
        return this.body.category
      },
      set (value) {
        this.body.category = value
      }
    },
    type: {
      get () {
        if (this.body.type === undefined) {
          this.body.type = this.$store.state.application.detail.classification.type
        }
        return this.body.type
      },
      set (value) {
        this.body.type = value
      }
    },
    supportEmail: {
      get () {
        if (this.body.support_email === undefined) {
          this.body.support_email = this.$store.state.application.detail.support_email
        }
        return this.body.support_email
      },
      set (value) {
        if (this.disabled) {
          this.body.support_email = this.$store.state.application.detail.support_email
        } else {
          this.body.support_email = value
        }
      }
    },
    url: {
      get () {
        if (this.body.app_url === undefined) {
          this.body.app_url = this.$store.state.application.detail.app_url
        }
        return this.body.app_url
      },
      set (value) {
        if (this.disabled) {
          this.body.app_url = this.$store.state.application.detail.app_url
        } else {
          this.body.app_url = value
        }
      }
    },
    allowMultiInstallPerAccount: {
      get () {
        if (this.body.allow_multi_install_per_account === undefined) {
          this.body.allow_multi_install_per_account = this.$store.state.application.detail.allow_multi_install_per_account
        }
        return this.body.allow_multi_install_per_account
      },
      set (value) {
        if (this.disabled) {
          this.body.allow_multi_install_per_account = this.$store.state.application.detail.allow_multi_install_per_account
        } else {
          this.body.allow_multi_install_per_account = value
        }
      }
    },
    isFree: {
      get () {
        if (this.body.is_free === undefined) {
          this.body.is_free = this.$store.state.application.detail.is_free
        }
        return this.body.is_free
      },
      set (value) {
        if (this.disabled) {
          this.body.is_free = this.$store.state.application.detail.is_free
        } else {
          this.body.is_free = value
        }
      }
    },
    isSynchronous: {
      get () {
        if (this.body.is_synchronous === undefined) {
          this.body.is_synchronous = this.$store.state.application.detail.is_synchronous
        }
        return this.body.is_synchronous
      },
      set (value) {
        if (this.disabled) {
          this.body.is_synchronous = this.$store.state.application.detail.is_synchronous
        } else {
          this.body.is_synchronous = value
        }
      }
    },
    applicationCategories: {
      get () {
        return this.$store.state.application.categories
      }
    }
  },
  watch: {
    type (value) {
      const appType = value === 'ExternalApp' ? 'tipo-aplicacao-externa' : 'tipo-aplicacao-interna'
      this.sendFsEvent(appType)
    },
    allowMultiInstallPerAccount (value) {
      const isActive = !!value

      if (isActive) this.sendFsEvent('multi-instalacao')
    }
  },
  data () {
    return {
      disabled: true,
      formIsValid: true,
      body: {
        name: undefined,
        category: undefined,
        type: undefined,
        support_email: undefined,
        app_url: undefined,
        allow_multi_install_per_account: undefined,
        is_free: undefined,
        is_synchronous: undefined
      },
      errors: [],
      form: form
    }
  },
  methods: {
    displayFeedback () {
      this.$refs.feedback.classList.add('displayFeedback')
      this.$refs.feedback.classList.remove('hideFeedback')
      setTimeout(() => {
        this.$refs.feedback.classList.remove('displayFeedback')
        this.$refs.feedback.classList.add('hideFeedback')
      }, 2000)
    },
    saveGeneralData (e) {
      e.preventDefault()
      const elements = [...e.target.elements]
      const invalidElements = elements.filter(element => element.willValidate).filter(element => !element.checkValidity())
      if (invalidElements.length === 0) {
        const submitButton = elements.filter(e => e.type === 'submit')[0]
        submitButton.classList.add('_state_loading')
        this.$store.dispatch('UPDATE_GENERAL_DATA', this.body)
          .then(response => {
            this.errors = []
            this.disabled = true
            this.displayFeedback()
            submitButton.classList.remove('_state_loading')
          })
          .catch(response => {
            submitButton.classList.remove('_state_loading')
            if (response.status === 400) {
              this.errors = response.body.errors
            }
          })
      } else {
        invalidElements.forEach(element => {
          form.addInputError(element)
        })
      }
    }
  },
  mounted () {
    this.$store.dispatch('SET_APPLICATION_CATEGORIES')
  },
  updated () {
    this.formIsValid = this.$refs.formGeneralData.checkValidity()
  }
}
</script>
<style scoped>
.emd-box._state_loading {
  height: 610px;
  background-repeat: no-repeat;
  background-image:
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4),
    linear-gradient(#f4f4f4);
  background-size:
    15% 25px,
    8% 20px,
    48% 39px,
    48% 39px,
    8% 20px,
    8% 20px,
    34% 22px,
    8% 20px,
    48% 39px,
    8% 20px,
    48% 39px;
  background-position:
    1.59% 4.35%,
    1.59% 15%,
    3% 20%,
    2.75% 37%,
    1.59% 31.5%,
    1.59% 51.5%,
    2.1% 56.25%,
    1.59% 66.5%,
    2.59% 73.5%,
    1.59% 83%,
    2.59% 90.6%;
  opacity: 1;
  animation: opacity 1s infinite ease-in;
}
</style>
